// TODO: DTM-966 - explicitly set enum values
/* eslint-disable @typescript-eslint/prefer-enum-initializers */

/* NOTE: Extracted from angular-cesium with updated types  */

export enum EditActions {
    INIT,
    MOUSE_MOVE,
    ADD_POINT,
    ADD_LAST_POINT,
    CHANGE_TO_EDIT,
    REMOVE_POINT,
    DRAG_POINT,
    DRAG_POINT_FINISH,
    DRAG_SHAPE,
    DRAG_SHAPE_FINISH,
    DONE,
    DISABLE,
    ENABLE,
    DISPOSE,
    SET_EDIT_LABELS_RENDER_CALLBACK,
    UPDATE_EDIT_LABELS,
    SET_MANUALLY,
    TRANSFORM,
}

export enum EditModes {
    CREATE,
    EDIT,
    CREATE_OR_EDIT,
}
